/* @flow strict */

import * as React from 'react';

type PropsType = {
  step?: number
};

class StepNavBar extends React.Component<PropsType> {
  props: PropsType;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      step: props.step || 1
    };
  }

  componentDidUpdate() {
    if (this.props.step !== this.state.step) {
      this.setState({ step: this.props.step });
    }
  }


  render = (): React.Element<'button'> => {
    const { step } = this.state;

    return (
      <div className="sparxo-step-bar">
        <div className={`sparxo-step-item ${step >= 1 ? 'active' : ''}`}>
          <i className="icon icon-pencil" />
        </div>
        <div className="sparxo-step-line" />
        <div className={`sparxo-step-item ${step >= 2 ? 'active' : ''}`}>
          <i className="icon icon-file" />
        </div>
        <div className="sparxo-step-line" />
        <div className={`sparxo-step-item ${step >= 3 ? 'active' : ''}`}>
          <i className="icon icon-collaborators" />
        </div>
        <div className="sparxo-step-line" />
        <div className={`sparxo-step-item ${step >= 4 ? 'active' : ''}`}>
          <i className="icon icon-share2" />
        </div>
      </div>
    );
  }
}

export default StepNavBar;
